/****************ELEMENTS*****************/

const timeDate = require('../../../../../js-handler/time-date')

export const tableDetail = {
      entity: 'emailTracking',
      dest: 'emailTracking',
      tdDataDetail: `data-detail='{ "clickRight": [
            {"dest":"emailTracking", "elem":"dt", "act":"trMenu", "id":"trMenu", "entity":"emailTracking", "dbid":"#dbid"}
      ]}'`,

      filter: {
            mainFilterFields: [
                  'email_tracking.email',
                  'email_tracking.status',
                  'email_tracking.email_type',
                  'email_tracking.entity',
                  'sender.__name',
                  'sender.last_name',
                  'recipient_provider.name',
                  'recipient_customer.name',
                  'recipient_user.username',
                  'recipient_user.last_name'
            ],
            mainFilterValues: ['', '', '', '', '', '', '', '', '', ''],
            andFilterFields: [],
            andFilterValues: [],
      }
}

/****************ELEMENTS*****************/

//each element could organize their data different
export function organizeRow(data) {

      var newData = []

      if (data.length === 0) {
            newData.push({
                  id: 'nothing', colum: [
                        { label: 'No Results', span: '' },
                        { label: '', span: '' },
                        { label: '', span: '' },
                        { label: '', span: '' },
                  ]
            })
            return newData
      }

      data.forEach((elem) => {
            newData.push(
                  {
                        id: elem.id, colum: [
                              {
                                    label: elem.sender_name,
                                    span: 'Sender',
                                    style: {
                                          tdClass: 'tdWithAvatar',
                                          avatar: elem.sender_avatar || '',
                                          avatarColor: '',
                                          avatarColorLetter: '',
                                          avatarLetter: ''
                                    }
                              },
                              {
                                    label: elem.recipient_name,
                                    span: elem.recipient_type,
                                    style: {
                                          tdClass: 'tdWithAvatar',
                                          avatar: elem.recipient_avatar || '',
                                          avatarColor: elem.recipient_avatarColor || '',
                                          avatarColorLetter: elem.recipient_avatarColorLetter || '',
                                          avatarLetter: elem.recipient_avatarLetter || ''
                                    }
                              },
                              { label: elem.email, span: getStatusDescription(elem.status) },
                              { label: timeDate.friendlyDate(elem.mail_datetime), span: String(elem.email_type || '').toUpperCase() }
                        ]
                  }
            )/*push*/
      })/*forEach*/

      return newData
}/*organizeRow*/

function getStatusDescription(status) {

      switch (String(status || '').toUpperCase()) {
            case 'PENDING': return 'The email has not been delivered yet'
            case 'SENT': return 'The email was successfully delivered to the recipient'
            case 'SPAM': return 'The recipient marked this email as spam'
            case 'BOUNCE': return 'The email could not be delivered to the recipient'
            case 'BLOCKED': return 'The email was blocked and could not be delivered'
            default: return "The email's delivery status could not be confirmed"
      }
}
